import styled, { css } from "vue-styled-components";

export const SWrapper = styled.div`
  display: block;
  background-color: ${({ theme }) => theme.colors.neutral.white};
`;

export const STableHeader = styled.div`
  display: grid;
  margin-bottom: 16px;
  gap: 20px;
  grid-template-columns: 40px 1fr 40px;
`;

export const STableHeaderArrow = styled("div", { content: String })`
  display: flex;
  align-items: center;
  justify-content: ${({ content }) => content};
  cursor: pointer;
`;

export const STableHeaderDays = styled.ul`
  list-style: none;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: uppercase;
`;

export const STableHeaderDay = styled("li", {
  isSelected: Boolean,
  default: false
})`
  margin: 0 12px;
  max-width: 70px;
  text-align: center;
  font-family: ${({ theme }) => theme.font.family.inter}, sans-serif;
  font-weight: ${({ theme }) => theme.font.weight.semiBold};
  font-size: ${({ theme }) => theme.font.size.sm};
  color: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.neutral.gray8 : theme.colors.neutral.gray5};
  line-height: 140%;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.neutral.gray8};
  }
`;

export const STableSlots = styled.div`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
`;

export const STableButton = styled("button", {
  isSelected: { type: Boolean, default: false }
})`
  ${({ theme, isSelected }) => css`
    padding: 12px 24px;
    display: inline-block;
    font-variant: normal;
    font-style: normal;
    font-weight: ${theme.font.weight.semiBold};
    font-family: ${theme.font.family.inter};
    font-size: ${theme.font.size.sm};
    white-space: nowrap;
    text-align: center;
    vertical-align: middle;
    border: 1px solid transparent;
    border-radius: 8px;
    overflow: hidden;
    outline: none;
    box-shadow: none;
    transition: all 0.3s ease;

    &:not(:disabled) {
      cursor: pointer;
    }

    color: ${isSelected
      ? theme.colors.brand.white
      : theme.colors.neutral.gray8};
    background-color: ${isSelected
      ? theme.colors.brand.primary
      : theme.colors.neutral.gray1};
    border-color: ${isSelected
      ? theme.colors.brand.primary
      : theme.colors.neutral.gray1};

    &:hover:enabled {
      color: ${theme.colors.brand.white};
      background-color: ${theme.colors.brand.primary};
      border-color: ${theme.colors.brand.primary};
    }

    &:focus:enabled,
    &.focus:enabled,
    &:active:enabled,
    &.active:enabled {
      color: ${isSelected
        ? theme.colors.neutral.white
        : theme.colors.neutral.gray8};
      background-color: ${isSelected
        ? theme.colors.brand.primary
        : theme.colors.neutral.gray1};
      border-color: ${isSelected
        ? theme.colors.brand.primary
        : theme.colors.neutral.gray1};
    }
  `}
`;

export const STableFooter = styled.div`
  margin-top: 24px;
  text-align: center;
`;

export const SShowMoreButton = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #495057;
`;

export const STableLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SEmptyState = styled.div`
  margin: 2.5rem 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  h4 {
    font-family: ${({ theme }) => theme.font.family.inter};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    font-size: ${({ theme }) => theme.font.size.md};
    color: ${({ theme }) => theme.colors.neutral.gray8};
  }

  p {
    max-width: 350px;
    font-family: ${({ theme }) => theme.font.family.inter};
    font-weight: ${({ theme }) => theme.font.weight.regular};
    font-size: ${({ theme }) => theme.font.size.sm};
    color: ${({ theme }) => theme.colors.neutral.gray6};
  }
`;
